<template>
  <li
    class="kpi-item"
    :style="{
      '--padding-factor-left': currentPageIndex > midPageIndex ? 0.75 : 0.25,
      '--padding-factor-right': currentPageIndex < midPageIndex ? 0.75 : 0.25,
    }"
  >
    <div class="kpi-item__value">{{ value }}</div>
    <div class="kpi-item__label">{{ label }}</div>
  </li>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: String,
  value: String,
  currentPageIndex: Number,
  totalPages: Number,
});

const midPageIndex = computed(() => Math.floor(props.totalPages / 2));
</script>

<style lang="scss" scoped>
.kpi-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 9.5vh 1rem;
  text-align: center;

  .desktop &,
  .large & {
    &:first-child {
      padding-left: calc(var(--page-padding-h) * var(--padding-factor-left));
    }

    &:last-child {
      padding-right: calc(var(--page-padding-h) * var(--padding-factor-right));
    }
  }

  .mobile &,
  .tablet & {
    border-bottom: 1px solid var(--scala-grigi-gray-3);
  }

  &__value {
    @include kpi-l;

    color: var(--page-color);
  }

  &__label {
    @include dida-s;

    max-width: toRem(190);
  }

  &:not(:last-child) {
    .desktop &,
    .large & {
      border-right: 1px solid var(--scala-grigi-gray-3);
    }
  }
}
</style>
